type FooterDisclaimerProps = {
  currentYear: number;
};

export default function FooterDisclaimer({
  currentYear,
}: FooterDisclaimerProps) {
  return (
    <div className="pt-8 border-t border-white/5">
      <div className="w-full">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-white/60 mb-4">
          Disclaimer
        </p>

        <div className="space-y-3 text-xs leading-relaxed text-white/50">
          <p>
            Investment Bastion is an informational and analytical service.
            Nothing on this website constitutes investment, financial, legal,
            or tax advice, an offer or solicitation, or a recommendation to
            buy, sell, or hold any security. The service does not take account
            of your objectives, financial situation, or needs.
          </p>

          <p>
            Data, estimates, scores, and model portfolio results may be
            delayed, incomplete, or inaccurate. Past performance is not
            indicative of future results. Investing involves risk, including
            the possible loss of capital. Conduct your own research and seek
            advice from an authorised professional where appropriate.
          </p>

          <p>
            INBASTION LIMITED is not authorised or regulated by the Financial
            Conduct Authority and does not provide regulated investment
            services. Use of the service is subject to our{" "}
            <a
              href="/terms"
              className="text-white/70 underline underline-offset-2 hover:text-white/90 transition-colors"
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              href="/risk-disclaimer"
              className="text-white/70 underline underline-offset-2 hover:text-white/90 transition-colors"
            >
              Risk Disclaimer
            </a>
            .
          </p>
        </div>

        <div className="mt-6 pt-6 border-t border-white/5 text-center space-y-1">
          <p className="text-xs text-white/45">
            &copy; {currentYear} INBASTION LIMITED. All rights reserved.
          </p>
          <p className="text-xs text-white/45">
            Registered in England and Wales under company number 16833422
          </p>
          <p className="text-xs text-white/45">
            Registered office: 1A Clonmel Road, Teddington, England, TW11 0SR
          </p>
        </div>
      </div>
    </div>
  );
}
